import api from "./api";

export interface RoleLimits {
  requestsPerMinute: number;
  decisionsPerDay: number;
  evidencePerDay: number;
  itemsPerRequest: number;
}

export interface RuntimeSettings {
  limits: {
    user: RoleLimits;
    admin: RoleLimits;
  };
  auth: {
    loginPerMinutePerIp: number;
    signupPerHourPerIp: number;
  };
  processing: {
    evidenceConcurrency: number;
  };
  updatedAt?: string | null;
  updatedBy?: { _id: string; email: string } | null;
}

export interface SettingsResponse {
  success: boolean;
  settings: RuntimeSettings;
  defaults: Omit<RuntimeSettings, "updatedAt" | "updatedBy">;
}

export const getSettings = async (): Promise<SettingsResponse> => {
  const { data } = await api.get<SettingsResponse>("/api/admin/settings");
  return data;
};

export const saveSettings = async (
  settings: Partial<RuntimeSettings>
): Promise<RuntimeSettings> => {
  const { data } = await api.put("/api/admin/settings", settings);
  return data.settings;
};
